module.exports = __webpack_public_path__ + "img/blacklist.c4797d2e.jpg";